import { useLocalization } from "@fluent/react";
import MenuItemSelector from "../../../MenuItemSelector";
import styles from "./DesktopCardSelector.module.scss";

export interface DesktopCardSelectorOption {
  id: API.CardId;
  label: string;
}

export interface DesktopCardSelectorProps {
  cardId: API.CardId;
  options: DesktopCardSelectorOption[];
  onChange: (id: API.CardId) => void;
}

const DesktopCardSelector = ({
  cardId,
  options,
  onChange,
}: DesktopCardSelectorProps) => {
  const { l10n } = useLocalization();
  const label = l10n.getString("subscription-card-label", null, "Card");

  const menuOptions = options.map((opt) => ({
    value: opt.id,
    label: opt.label,
  }));

  return (
    <div className={styles.container}>
      <MenuItemSelector
        options={menuOptions}
        selected={cardId}
        onSelect={onChange as (cardId: string) => void}
        label={label}
        labelIcon="narmi-icon-credit-card1"
      />
    </div>
  );
};

export default DesktopCardSelector;
